import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import {provideToastr} from 'ngx-toastr';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {InterceptorsProvider} from './providers/interceptorsprovider';
import {ConfirmationService} from 'primeng/api';
import {RECAPTCHA_SETTINGS, RecaptchaSettings} from 'ng-recaptcha-2';
import {environment} from '../environments/environment';
import {DatePipe, registerLocaleData} from '@angular/common';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import localeFr from '@angular/common/locales/fr';
import { HttpClient } from '@angular/common/http';
registerLocaleData(localeFr, 'fr');

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    provideHttpClient(),
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideToastr({
      closeButton: true,
      progressBar: true
    }),
    provideHttpClient(withInterceptorsFromDi()),
    InterceptorsProvider,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.GOOGLE_CAPTCHA_SITE_KEY } as RecaptchaSettings,
    },
    DatePipe
  ],
};
